import type { IconProps } from '../types/IconProps.ts';
export const GalleryVertical: IconProps = {
    name: 'GalleryVertical',
    children: [
        `<path d="M2.99 2h18M3.01 22h18" />`,
        `<rect width="18" height="12" x="3" y="6" rx="2" />`,
    ]
};